import Vue from 'vue'
import Vuex from 'vuex'
import router from './router';
import axios from "axios";

Vue.use(Vuex)

export default new Vuex.Store({
    state: {
        accessToken: null,
        refreshToken: null,
        userid: null,
        userimage: null,
        alert: null,
        loading: false,
        user: null,
        payment_to: null,
        //clientToken: process.env.VUE_APP_CLIENT_TOKEN
    },
    mutations: {
        storeToken(state, token) {
          state.accessToken = token
        },
        storePaymentTo(state, payment_to) {
          state.payment_to = payment_to
        },
        storeAuthData(state, data) {
          state.accessToken = data.access
          state.refreshToken = data.refresh
          state.loading = true
        },
        storeUserData(state, data) {
          console.log('user data')
          console.log(data)
          state.userid = data.profile.user_id
          state.userimage = data.profile.photo
          localStorage.setItem('userid', state.userid)
          localStorage.setItem('userimage', state.userimage)
        },
        logoutUser(state) {
          state.accessToken = null
          state.refreshToken = null
          localStorage.removeItem('accessToken')
          localStorage.removeItem('refreshToken')
          localStorage.removeItem('userid')
          localStorage.removeItem('userimage')
          //localStorage.removeItem('expDate')
        },
        loading(state, loading) {
          if (loading) {
            state.loading = true;
          } else {
            state.loading = false
          }
        }
    },
    actions: {
      resetPassword (data) {
        return new Promise((resolve, reject) => {
          axios.post('/users/set-password/', data)
          .then(res => {
            resolve(res)
            return router.push('signin')
          }, error => {
            if (error.response) {
              // The request was made and the server responded with a status code
              // that falls out of the range of 2xx
              console.log(error.response.data);
              console.log(error.response.status);
              console.log(error.response.headers);
              return error.response
            } else if (error.request) {
              // The request was made but no response was received
              // `error.request` is an instance of XMLHttpRequest in the browser and an instance of
              // http.ClientRequest in node.js
              console.log(error.request);
            } else {
              // Something happened in setting up the request that triggered an Error
              console.log('Error', error.message);
            }
            console.log(error.config);
            reject(error)
          })
          .catch(error => {
              console.log(error)
              reject(error)
          });
        })
      }
    },
  getters: {
    getToken(state) {
        return state.accessToken
    },
    isLoading (state) {
      return state.loading
    },
    getPaymentTo (state) {
      return state.payment_to
    },
    isAuthenticated(state) {
        return state.accessToken != null
    }
  }
})
